var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgFullStar = function SvgFullStar(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 31,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "m17.832 1.285 3.902 7.519 8.947 1.523c1.475.285 1.713 2.046.714 3.236l-6.187 6.186 1.19 8.043c.476 2.57-1.047 3.521-3.189 2.474l-7.233-3.76-7.186 3.76c-2.141 1.047-3.664.095-3.188-2.474l1.142-8.043-6.139-6.186c-.999-1.19-.761-2.95.714-3.236l8.947-1.523 3.902-7.519c.714-1.665 2.903-1.76 3.664 0Z",
    fill: "#4E6DF5"
  })));
};
export default SvgFullStar;